import { useTranslation } from '../../../i18n';
import React, { useState } from 'react';
import { Button, Card, Modal, Select, Spin, Tag, Typography } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import CompactTable from './CompactTable';
import { runAction } from './utils';

const { Text } = Typography;
const MAX_GROUPS = 5;

const SecurityGroupTab = ({ id, api, network, loading, reloadNetwork, isMobile, disabled }) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState([]);
    const [saving, setSaving] = useState(false);

    if (loading && !network) return <div style={{ textAlign: 'center', padding: 48 }}><Spin /></div>;

    const supported = !!network?.security_groups_supported;
    const bound = network?.security_groups || [];
    const available = network?.available_security_groups || [];

    const openEdit = () => {
        setSelected(bound.map((g) => g.id));
        setOpen(true);
    };

    const save = async () => {
        setSaving(true);
        const res = await runAction(() => api.setVmSecurityGroups(id, selected), t('Security group updated'), t('Failed to update security group'));
        setSaving(false);
        if (res) {
            setOpen(false);
            reloadNetwork();
        }
    };

    const columns = [
        {
            title: t('Name'), key: 'name', render: (_, g) => (
                <span>{g.name}{Number(g.is_default) ? <Tag style={{ marginLeft: 8 }}>{t('Default')}</Tag> : null}</span>
            ),
        },
        { title: t('Rule count'), key: 'rules_count', render: (_, g) => g.rules_count ?? '-' },
    ];

    return (
        <Card
            size="small"
            title={t('Security groups')}
            extra={(
                <Button size="small" icon={<EditOutlined />} onClick={openEdit} disabled={disabled || !supported}>
                    {t('Change binding')}
                </Button>
            )}
        >
            {!supported && <Text type="secondary" style={{ display: 'block', marginBottom: 8 }}>{t('Security group binding coming soon')}</Text>}
            <CompactTable isMobile={isMobile} columns={columns} dataSource={bound} emptyText={t('No security group bound')} />

            <Modal title={t('Attach security group')} open={open} onCancel={() => setOpen(false)} onOk={save} confirmLoading={saving} destroyOnClose>
                <Select
                    mode="multiple"
                    style={{ width: '100%' }}
                    placeholder={t('Up to {{MAX_GROUPS}}', { MAX_GROUPS: MAX_GROUPS })}
                    value={selected}
                    onChange={setSelected}
                    maxCount={MAX_GROUPS}
                    optionFilterProp="label"
                    options={available.map((g) => ({ value: g.id, label: `${g.name}${Number(g.is_default) ? t('(Default)') : ''}` }))}
                />
            </Modal>
        </Card>
    );
};

export default SecurityGroupTab;
